// import React, { useState } from 'react'
// import NavbarComponent from '../components/navbar-component/navbar-component'
// import styled from 'styled-components';
// import { Breadcrumb } from 'rsuite';
// import { Link, useNavigate } from 'react-router-dom';
// import FooterComponent from '../components/common/footer-component/footer-component';
// import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
// import { Download as DownloadIcon } from '@mui/icons-material';
// import { BaseUrl } from '../api/axios';
// import { Configurations } from '../config';
// import { Document, Page } from 'react-pdf';

// export default function StudentResultPage() {

//     const Container = styled.div`
//   max-width: 1000px;
//   margin: 0 auto;
//   padding: 20px;
//   font-family: Arial, sans-serif;
//   color: #333;
// `;

// const Title = styled.h1`
//   text-align: center;
//   font-size: 1.8em;
//   margin-bottom: 20px;
//   font-family: Arial, sans-serif;
// `;
// const navigate = useNavigate();


// const downloadLinks = [
//     {
//       title: "Nomination Form – University Provident Fund",
//       //description: "A clean and modern resume template for professionals.",
//       url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
//     },
//     {
//       title: "Information for Recruitment of Contract and Temporary Employees",
//       //description: "A comprehensive proposal template for project planning.",
//       url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Information-for-Recruitment-of-Contract-and-Temporary-Employees.pdf",
//     },
//     {
//       title: "Check List - Application for the Post of Professor",
//       //description: "An example business report format for corporate use.",
//       url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Document-Check-List-for-the-Professor-Application.docx",
//     }
//   ];

//   // return (
//   //  <>
//   //  <NavbarComponent />
//   //  <div class="container">
//   //     <div>
//   //       <Breadcrumb separator={">"}>
//   //           <Breadcrumb.Item as={Link} onClick={()=>navigate("/home")} href="#">
//   //           Home
//   //           </Breadcrumb.Item>
//   //           <Breadcrumb.Item as={Link} >
//   //           Downloads
//   //           </Breadcrumb.Item>
//   //       </Breadcrumb>
//   //   </div>
//   //   </div>

//   //  <Container>
        
//   //     <Title>Downloads</Title>


//   //   <Box sx={{ textAlign: 'center', padding: 4 }}>
    
//   //     <Grid container spacing={4} justifyContent="center">
//   //       {downloadLinks.map((link, index) => (
//   //         <Grid item style={{ width:'100%',textAlign:'left' }}  key={index}>
//   //           <Card >
//   //             <CardContent>
//   //               <Typography 
//   //               component="div">
//   //                 <span style={{ fontFamily: 'Arial, sans-serif',fontSize:18,fontWeight:500 }}>{link.title}</span>
//   //               </Typography>
//   //               <Typography variant="body2" color="text.secondary" paragraph>
                 
//   //               </Typography>
//   //               <Button
//   //                 variant="contained"

//   //                 style={{ backgroundColor:'white',color:'#990000'   }}
//   //                 href={link.url}
//   //                 download
//   //                 startIcon={<DownloadIcon />}
//   //                 fullWidth
//   //                 target='_blank'
                     
//   //               >
//   //                 Download
//   //               </Button>
//   //             </CardContent>
//   //           </Card>
//   //         </Grid>
//   //       ))}
//   //     </Grid>
//   //   </Box>


//   //     <div style={{ padding:200 }}></div>
//   //   </Container>
//   //   <FooterComponent />
//   //  </>
//   // )


//   const [numPages, setNumPages] = useState(0);
//   const [pageNumber, setPageNumber] = useState(1);

 

//   const onDocumentLoadSuccess =(numPages) => {
//     setNumPages(numPages);
//   }

//   return (
//     <div>
//       <Document file="somefile.pdf" onLoadSuccess={onDocumentLoadSuccess}>
//         <Page pageNumber={pageNumber} />
//       </Document>
//       <p>
//         Page {pageNumber} of {numPages}
//       </p>
//     </div>
//   );
// }




import React, { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import mypdf from '../../src/Dental.pdf'
import IframeComponent from '../components/dynamic-iframe-component/common-iframe';
import { Accordion, Breadcrumb, Placeholder } from 'rsuite';
import NavbarComponent from '../components/navbar-component/navbar-component';
import StudentResultModel from '../components/Models/student-result-model';
import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ViewBarComponent from '../components/common/view-bar-component';

const StudentResultPage = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  // Function to handle when the document is loaded
  function onLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const [selectedPDFURL,setSelectedPDFUrl] = useState(null);
  const [isOpenModel, setIsModelOpen] = useState(false);

  const handleShowModel = () => {

  }

  useEffect(()=>{
    if(selectedPDFURL != null){
      setIsModelOpen(true);
    }
  },[selectedPDFURL])

  return (
    <div>
       <NavbarComponent />
      <div class="container">

      <div>
        <Breadcrumb separator={">"}>
            <Breadcrumb.Item href='/home'>
            Home
            </Breadcrumb.Item>
            <Breadcrumb.Item >
            Student Result
            </Breadcrumb.Item>
        </Breadcrumb>
      </div>

        {/* <IframeComponent iframeSrc={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2023/Dental.pdf`} /> */}
        <Accordion defaultActiveKey={1} bordered>



        <Accordion.Panel header="Results-2026" eventKey={1}>
        
          <ViewBarComponent title="Final Examination for BDS Degree Part 1 (Repeat) August/ September 2026" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2026/Final Examination for BDS Degree Part I(Repeat).pdf`} /> 

          <ViewBarComponent title="First Examination for BDS Degree August 2026" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2026/First Examinatio for BDS Degree August 2026.pdf`} /> 
          <ViewBarComponent title="Final Examination for BDS Degree Part I" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2026/Final Examination for BDS Degree Part I - May 2026.pdf`} /> 
            <ViewBarComponent title="Second Examination for BDS Degree - March 2026" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2026/2nd BDS Repeat Examination - March 2026 (2021-2022 Batch) - Final Results.pdf`} /> 
        </Accordion.Panel>

        <Accordion.Panel header="Results-2025" eventKey={2}>
            <ViewBarComponent title="Second Examination for BDS Degree December 2025" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2025/2nd Examination for BDS Degree - December 2025.pdf`} /> 
            <ViewBarComponent title="First Examination for BDS Degree - November/December 2025" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2025/1st BDS Repeat Examination - November-December 2025.pdf`} /> 
            <ViewBarComponent title="First Examination for BDS Degree - August 2025" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2025/Results Sheet- 1st Examination for BDS Degree (3rd Dental Batch).pdf`} /> 
        </Accordion.Panel>


          <Accordion.Panel header="Results-2024" eventKey={3}>
              <ViewBarComponent title="Second Examination for BDS Degree - January 2025 -  Year of Admission 2020/2021" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2024/2nd BDS Examination Results- January 2025.pdf`} /> 
              <ViewBarComponent title="First Examination for BDS Degree - December 2024 -  Year of Admission 2021/2022" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2024/1st BDS Results December 2024.pdf`} /> 
              <ViewBarComponent title="First Examination for BDS Degree - August/September 2024 -  Year of Admission 2021/2022" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2024/2nd Batch - 1st BDS Results - FDS.pdf`} />
          </Accordion.Panel>

          <Accordion.Panel header="Results-2023" eventKey={4}>
            <ViewBarComponent title="First Examination for BDS Degree - November/December 2023 -  Year of Admission 2020/2021" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2023/Dental results november december 2023.pdf`} />
            <ViewBarComponent title="First Examination for BDS Degree - August 2023 -  Year of Admission 2020/2021" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2023/Results of 1st Examination for BDS Degree_ 1st Dental Batch_ August 2023 (1).pdf`} />
            <ViewBarComponent title="Results of English Language Competency Test -First BDS Examination - August 2023 -  First Dental Batch 2020/2021" setSelectedPDFUrl={setSelectedPDFUrl} url={`https://usjnetsso.sjp.ac.lk/assets/examSheet/dentalScience_2023/Results of English Language Competency Test_ 1st BDS Examination_ August 2023_ 1st Dental Batch.pdf`} />
            <StudentResultModel openModel={isOpenModel} resultURL={selectedPDFURL} setIsModelOpen={setIsModelOpen} setSelectedPDFUrl={setSelectedPDFUrl}/>
          </Accordion.Panel>
         
  
        </Accordion>
      </div>
    </div>
    
  );
};

export default StudentResultPage;


